export default "__VITE_ASSET__CskBjvUv__"